import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import FacilitiesList from "../../features/ManageFacilities/facilitiesList";
import FacilityTopbar from "../../features/ManageFacilities/topbar";
import { Box, CardMedia, IconButton, Typography, Tabs, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import { showError, showToast } from "../../constants/toasts";
import { GridColDef } from "@mui/x-data-grid";
import moment from "moment";
import AddFacility from "../../Modals/addFacilities";
import { ConfirmationModal } from "../../Modals/ConfirmationModal";
import CustomToggle from "../../helpers/CustomToggle";
import {
  useLazyGetFacilitiesQuery,
  useAddFacilityMutation,
  useDeleteFacilityMutation,
  useUpdateFacilityMutation,
} from "../../services/facility";

const ManageFacilities = () => {
  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [fetchFacilities, { isLoading }] = useLazyGetFacilitiesQuery();
  const [addFacility, { isLoading: addLoading }] = useAddFacilityMutation();
  const [updateStatus] = useUpdateFacilityMutation();
  const [deleteFacility] = useDeleteFacilityMutation();

  const [selectedId, setSelectedId] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [add, setAdd] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openStatusConfirm, setOpenStatusConfirm] = useState(false);
  const [edit, setEdit] = useState(false);
  const [facilityName, setFacilityName] = useState("");
  const [Image, setImage] = useState<string>("");
  const [statusToUpdate, setStatusToUpdate] = useState<{
    id: string;
    status: boolean;
  } | null>(null);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [facilitiesListing, setFacilitiesList] = useState([]);
  const selectedType = valueTabs === 0 ? "VENUE" : "STORAGE";

  const onPageChange = (_: any, newPage: number) => {
    setPage(newPage);
  };

  const columns: GridColDef<(typeof facilitiesListing)[number]>[] = [
    {
      flex: 2,
      minWidth: 220,
      field: "name",
      headerName: "Name",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 180,
      field: "image",
      headerName: "Image",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <img
            src={row?.image}
            alt={"Edit"}
            style={{
              width: 32,
              height: 32,
              borderRadius: 4,
              objectFit: "cover",
            }}
          />
        );
      },
    },
    {
      flex: 1,
      minWidth: 180,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: (_: any) => {
        return (
          <Typography>{moment(_?.createdAt).format("DD MMMM YYYY")}</Typography>
        );
      },
    },

    {
      flex: 1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }: any) => {
        return (
          <CustomToggle
            checked={!row?.status}
            onChange={() => {
              setStatusToUpdate({ id: row?._id, status: !row?.status });
              setOpenStatusConfirm(true);
            }}
            id={row?._id} // size="small"
          />
        );
      },
    },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setFacilityName(row?.name || "");
                  setImage(row?.image || "");
                  setEdit(true);
                  setOpen(true);
                }}
              >
                <img src="/static/images/edit2_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setOpenDelete(true);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    try {
      const response = await deleteFacility({ id: selectedId }).unwrap();
      if (response?.statusCode === 200) {
        showToast("Deleted Successfully");
        getFacilities();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleStatusUpdate = async (id: string, status: boolean) => {
    const body = {
      status: status,
    };

    try {
      const response = await updateStatus({ body, id }).unwrap();
      if (response?.statusCode === 200) {
        showToast(
          `Facilitie ${!status ? "activated" : "deactivated"} successfully`
        );
        getFacilities();
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleConfirmedStatusUpdate = async () => {
    if (statusToUpdate) {
      await handleStatusUpdate(statusToUpdate.id, statusToUpdate.status);
      setOpenStatusConfirm(false);
      setStatusToUpdate(null);
    }
  };

  const handleSubmit = async (name: string, image?: string) => {
    if (!name?.length) {
      showError("Please input facility name");
      return;
    }
    try {
      let response = {} as any;
      if (edit) {
        response = await updateStatus({
          body: {
            name,
            image: image || "image",

          },
          id: selectedId,
        } as any).unwrap();
      } else {
        response = await addFacility({
          name,
          image: image || "image",
          type: selectedType,
        } as any).unwrap();
      }
      if (response?.statusCode === 200) {
        setFacilityName("");
        setImage("");
        setAdd(false);
        setOpen(false);
        setEdit(false);
        getFacilities();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      console.log(error);
    }
  };

  const getFacilities = async () => {
    try {
      const response = await fetchFacilities({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        type: selectedType,
      } as any).unwrap();
      if (response?.statusCode === 200) {
        setFacilitiesList((response?.data?.data || []) as any);
        setTotalCount(response?.data?.total);
      } else {
        setFacilitiesList([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getFacilities();
  }, [debouncedSearchTerm, page, valueTabs]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Facilities</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Facilities
        </p>
      </div>
      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="facilities type tabs"
              className="custom_tabs_links"
            >
              <Tab label="Venue" />
              <Tab label="Storage" />
            </Tabs>
          </Box>
        </div>
      </div>
      <div className="cards">
        <FacilityTopbar
          searchTerm={searchTerm}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          setSearchTerm={setSearchTerm}
          toggleModal={() => {
            setEdit(false);
            setFacilityName("");
            setImage("");
            setSelectedId("");
            setOpen(true);
          }}
        />
        <FacilitiesList
          count={totalCount}
          page={page}
          loading={isLoading}
          onPageChange={onPageChange}
          rows={facilitiesListing || []}
          columns={columns}
        />
      </div>
      <AddFacility
        edit={edit}
        value={facilityName || ""}
        facilityImage={Image || ""}
        setFacilityName={setFacilityName}
        loading={addLoading}
        handleSubmit={handleSubmit}
        open={open}
        onClose={() => {
          handleCloseModal();
          setEdit(false);
          setFacilityName("");
          setImage("");
          setSelectedId("");
        }}
        setOpen={setOpen}
      />

      <ConfirmationModal
        text={"Are you sure to delete this facilities"}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />

      <ConfirmationModal
        text={`Are you sure you want to ${statusToUpdate?.status ? "deactivate" : "activate"
          } this facilities?`}
        openModal={openStatusConfirm}
        setOpenModal={setOpenStatusConfirm}
        handleSubmit={handleConfirmedStatusUpdate}
      />
    </MainContainer>
  );
};

export default ManageFacilities;
